import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IListTarifa } from '../../models/cotizador/IListTarifa';
import { IDataTarifa } from '../../models/cotizador/IDataTarifa';
import { CampaniaRequest, QuotationPeopleeRequest } from "../../models/cotizador/request/model.data.request";
import { campanias, relationship, documentsType, QuotationPeopleeResponse, Beneficiarios } from "../../models/cotizador/response/model.data.response";
import { ModelDefaultResponse } from "../../models/cotizador/response/model.default.response";
import { catchError, concatMap, from, map, Observable, of, throwError, toArray } from "rxjs";
import { AdresPerson, AdresResponse } from '../../models/cotizador/response/model.adres.response';
import { ConsultarCiudadesResponse } from '../../models/cotizador-contratante/consultar-ciudades/consultar-ciudades-response.model';
import { ConsultarSubcuentasResponse } from '../../models/cotizador-contratante/consultar-subcuentas/ressponse/consultar-subcuentas-response.model';
import { ConsultarSubcuentasRequest } from '../../models/cotizador-contratante/consultar-subcuentas/request/consultar-subcuentas-request.model';
import { ConsultarTipoViaBackendResponse, TipoViaItem } from '../../models/cotizador-contratante/consultar-tipo-via/response/consultar-tipo-via-response.model';
import { ConsultarTipoViaRequest } from '../../models/cotizador-contratante/consultar-tipo-via/request/consultar-tipo-via-request.model';
import { environment } from '../../../environments/environment';
import { URL_MAP } from "../../shared/urlMap";
import {
  ActivoAcColectivoItem,
  ProgramaSeleccionadoCampaniaInput,
  SubcuentasOrquestadoResult,
  TarifaLegacyLookupParams
} from '../../models/beneficiario';
import {
  buildPairKey,
  getEsUsuarioFromLocalContratante,
  getIdContratanteFromLocal,
  getIdCotizacionFromLocal,
  normalizeCampaignDate,
  normalizeTipoPlanTarifa,
  normTxt,
  resolverCuentaPorTipoPlan,
  toBooleanFromSN,
  toSafeNumber
} from './utils';

export { ActivoAcColectivoItem, SubcuentasOrquestadoResult } from '../../models/beneficiario';
export { TarifaLegacyLookupParams } from '../../models/beneficiario';

@Injectable({
  providedIn: 'root'
})

export class NetworkingBeneficiary {

  networkingOutput?: any;
  private readonly servicioParentesco = `${environment.HOST}${URL_MAP.API.PARENTESCO_SERVICIO}`;
  private readonly servicioCampania = `${environment.HOST}${URL_MAP.API.CONSULTAR_CAMPANAS_NUEVAS}`;
  private readonly servicioTarifaIndividualLegacy = `${environment.HOST}${URL_MAP.API.CONSULTAR_TARIFAS_INDIVIDUALES}`;
  private readonly servicioTarifaIndividual = `${environment.HOST}${URL_MAP.API.CONSULTAR_TARIFAS_INDIVIDUALES_VALORES}`;
  private readonly servicioTarifaColectiva = `${environment.HOST}${URL_MAP.API.COT_CONSULTAR_TARIFA}`;
  private readonly servicioDocuemento = `${environment.HOST}${URL_MAP.API.DOCUMENTOS_TIPOS_DOCUMENTOS}`;
  private readonly servicioDatosUsuario = `${environment.HOST}${URL_MAP.API.CONSULTAR_DATOS_USUARIO}`;
  private readonly servicioAdres = `${environment.HOST}${URL_MAP.API.CONSULTAR_ADRES_SERVICIO}`;
  private readonly servicioCiudad = `${environment.HOST}${URL_MAP.API.CONSULTAR_CIUDADES}`;
  private readonly servicioActivoAC = `${environment.HOST}${URL_MAP.API.CONSULTA_ACTIVO_AC}`;
  private readonly servicioSubcuentas = `${environment.HOST}${URL_MAP.API.CONSULTAR_SUBCUENTAS}`;
  private readonly servicioTipoVia = `${environment.HOST}${URL_MAP.API.CONSULTAR_TIPOS_VIA_SERVICIO}`;
  private readonly servicioAnexos = `${environment.HOST}${URL_MAP.API.ANEXOS_COLECTIVOS_GRUPOS}`;
  private readonly servicioDatosBeneficiarios = `${environment.HOST}${URL_MAP.API.GUARDAR_DATOS_BENEFICIARIOS}`;
  private readonly servicioActualizarDatosBeneficiarios = `${environment.HOST}${URL_MAP.API.ACTUALIZAR_DATOS_BENEFICIARIOS}`;
  private readonly servicioEliminarDatosBeneficiarios = `${environment.HOST}${URL_MAP.API.ELIMINAR_DATOS_BENEFICIARIOS}`;
  private readonly servicioGuardarBeneficiarioProgramas = `${environment.HOST}${URL_MAP.API.GUARDAR_BENEFICIARIO_PROGRAMAS}`;
  private readonly servicioActualizarBeneficiarioProgramas = `${environment.HOST}${URL_MAP.API.ACTUALIZAR_BENEFICIARIO_PROGRAMAS}`;
  private readonly servicioEliminarBeneficiarioProgramas = `${environment.HOST}${URL_MAP.API.ELIMINAR_BENEFICIARIO_PROGRAMAS}`;
  private readonly servicioGuardarSubcuenta = `${environment.HOST}${URL_MAP.API.GUARDAR_SUBCUENTAS}`;
  private readonly servicioActualizarSubcuenta = `${environment.HOST}${URL_MAP.API.ACTUALIZAR_SUBCUENTAS}`;
  private readonly servicioEliminarSubcuentas = `${environment.HOST}${URL_MAP.API.ELIMINAR_SUBCUENTAS}`;
  private readonly servicioGuardarTarifa = `${environment.HOST}${URL_MAP.API.GUARDAR_TARIFAS}`;
  private readonly servicioActualizarTarifa = `${environment.HOST}${URL_MAP.API.ACTUALIZAR_TARIFAS}`;
  private readonly servicioEliminarTarifas = `${environment.HOST}${URL_MAP.API.ELIMINAR_TARIFAS}`;
  private readonly servicioGuardarCampanias = `${environment.HOST}${URL_MAP.API.GUARDAR_CAMPANIAS}`;
  private readonly servicioActualizarCampanias = `${environment.HOST}${URL_MAP.API.ACTUALIZAR_CAMPANIAS}`;
  private readonly servicioEliminarCampanias = `${environment.HOST}${URL_MAP.API.ELIMINAR_CAMPANIAS}`;
  private readonly servicioConsultarBeneficiarioPrograma = `${environment.HOST}${URL_MAP.API.CONSULTAR_BENEFICIARIO_PROGRAMA}`;
  private ultimaMetaTarifasIndividuales = {
    legacyConDatos: false,
    valoresConDatos: false
  };

  getUltimaMetaTarifasIndividuales(): { legacyConDatos: boolean; valoresConDatos: boolean; } {
    return { ...this.ultimaMetaTarifasIndividuales };
  }

  constructor(private httpClient: HttpClient) { }

  consultarParentescos(): Observable<relationship[]> {
    const url = this.servicioParentesco;
    const body = {
      "nombreClave": "getSpParentesco",
      "jsonParametros": "{}"
    };

    return this.httpClient.post<ModelDefaultResponse<any>>(url, body).pipe(
      map((response: ModelDefaultResponse<any>) => {
        let data: any = response;
        let result: relationship[] = data;
        return result;
      }),
      catchError(error => {
        return throwError(() => new Error((error) ? error.message : "Error en la búsqueda de parentescos"));
      })
    );
  }

  bucarCampa(data: CampaniaRequest): Observable<campanias[]> {
    const url = this.servicioCampania;
    const tipoPlan = data.codigo_tipo_plan || (data as any).vc_tipoPlan || '';
    const planNorm = normTxt(tipoPlan || localStorage.getItem('tipoPlan') || '');
    const cuentaActual = String(data.cuenta || (data as any).vc_cuenta || '');
    const cuenta = resolverCuentaPorTipoPlan(planNorm, cuentaActual);
    const edad = String(data.edad || (data as any).vc_edad || '');
    const modeloNegocio = Array.isArray(data.modelo_negocio) ? data.modelo_negocio[0] : null;

    const subcuenta = (modeloNegocio?.subcuenta || (data as any).vc_subcuenta || '').toString().trim();
    const lineaNegocio = String(modeloNegocio?.linea_negocio || (data as any).vc_lineaNegocio || '');
    const programa = (Array.isArray(modeloNegocio?.programa) ? modeloNegocio.programa[0] : null) || (data as any).vc_programa || '';

    const grupoProgramaFromPayload = ((modeloNegocio as any)?.grupo_programa || (modeloNegocio as any)?.grupoPrograma || (data as any).vc_grupoPrograma || '').toString().trim();
    const grupoPrograma = grupoProgramaFromPayload;

    const esColectivo = planNorm === 'C' || planNorm === 'CY' || planNorm === 'GA' || planNorm === 'AG' || planNorm.includes('COLECTIV') || planNorm.includes('AFINIDAD');
    const subcuentaParam = subcuenta || (esColectivo ? subcuenta : '');
    const grupoProgramaParam = esColectivo ? grupoPrograma : '';
    const cuentaParam = cuenta;

    const jsonParams = {
      nu_pagina: '1',
      nu_tamanoPagina: '1000',
      vc_codigoCampana: (data as any).vc_codigoCampana || '',
      vc_nombreComercial: '',
      vc_lineaNegocio: lineaNegocio,
      vc_cuenta: cuentaParam,
      vc_subcuenta: subcuentaParam,
      vc_grupoPrograma: grupoProgramaParam,
      vc_programa: programa,
      vc_tipoPlan: planNorm,
      fe_inicioVig: '',
      fe_finVig: '',
      nu_acumulable: '',
      nu_debitoAuto: '',
      nu_prontoPago: '',
      vc_genero: String(data.sexo || (data as any).vc_genero || ''),
      vc_edad: edad,
      vc_parentesco: (data as any).vc_parentesco ?? '',
      vc_cod_tarifa: (data as any).vc_cod_tarifa || ''
    };

    const body = {
      nombreClave: 'getCampaniaCtz',
      jsonParametros: JSON.stringify(jsonParams)
    };

    return this.httpClient.post<any>(url, body).pipe(
      map((resp) => {
        if (!resp || resp.status !== true) {
          const msg = resp?.message || resp?.errorMessage || 'No fue posible consulting campañas.';
          throw new Error(msg);
        }
        const items = Array.isArray(resp?.data?.jsonRespuesta) ? resp.data.jsonRespuesta : (Array.isArray(resp?.data) ? resp.data : []);
        const lista: campanias[] = items.map((it: any) => ({
          modalidad: it.MODALIDAD ?? '',
          nombre: it.NOMBRE_CAMPANIA ?? '',
          tarifa: it.TARIFA ?? '',
          descripcionTarifa: it.NOMBRE_CAMPANIA ?? '',
          cuenta: Number(it.CUENTA ?? 0),
          subcuenta: it.SUBCUENTA ?? '',
          codigo_campania: it.COD_CAMP_COMERCIAL ?? '',
          tipo_campania: it.TIPO_CAMPANIA ?? '',
          solo_nuevos: it.SOLO_NUEVOS ?? '',
          ingresa_moroso: it.INGRESA_MOROSO ?? '',
          meses_mora_permitidos: (it.MESES_MORA_PERMITIDOS === 'null' || !it.MESES_MORA_PERMITIDOS ? '' : it.MESES_MORA_PERMITIDOS) ?? '',
          bonifica_moroso: it.BONIFICA_MOROSO ?? '',
          id_campania: toSafeNumber(it.ID_CAMPANIA, 0),
          linea_negocio: (it.LINEA_NEGOCIO ?? '').toString().trim(),
          grupo_programa: (it.GRUPO_PROGRAMA ?? '').toString().trim(),
          programa: (it.PROGRAMA ?? '').toString().trim(),
          tipo_plan: (it.TIPO_PLAN ?? '').toString().trim(),
          parentesco: (it.PARENTESCO ?? '').toString().trim(),
          edad_desde: toSafeNumber(it.EDAD_DESDE, 0),
          edad_hasta: toSafeNumber(it.EDAD_HASTA, 0),
          cant_benef_desde: toSafeNumber(it.CANT_BENEF_DESDE, 0),
          cant_benef_hasta: toSafeNumber(it.CANT_BENEF_HASTA, 0),
          acumulable: toBooleanFromSN(it.ACUMULABLE),
          pago_debito_auto: toBooleanFromSN(it.PAGO_DEBITO_AUTO),
          aplica_pronto_pago: toBooleanFromSN(it.APLICA_PRONTO_PAGO),
          observaciones: (it.OBSERVACIONES ?? '').toString().trim(),
          usuario_actualizacion: '',
          inicio_vigencia: normalizeCampaignDate(it.INICIO_VIGENCIA),
          fin_vigencia: normalizeCampaignDate(it.FIN_VIGENCIA),
          estado: toBooleanFromSN(it.ESTADO),
          genero: (it.GENERO ?? '').toString().trim()
        }));
        return lista;
      }),
      catchError((error) => {
        const msg = error?.message || error?.error?.message || 'Error consultando campañas';
        return throwError(() => new Error(msg));
      })
    );
  }

  bucarTarifas(data: IDataTarifa, esInclusion = false): Observable<IListTarifa[]> {
    const url = this.servicioTarifaIndividual;
    const modeloNegocio = Array.isArray(data?.modelo_negocio) ? data.modelo_negocio[0] : null;
    const cuenta = Number(data?.cuenta ?? 0);
    const cuentaValida = Number.isFinite(cuenta) && cuenta > 0 ? cuenta : 1;
    const tipoPlanRaw = ((data as any)?.codigo_tipo_plan ?? localStorage.getItem('tipoPlan') ?? '').toString();
    const planNorm = normTxt(tipoPlanRaw);
    const cuentaResueltaStr = resolverCuentaPorTipoPlan(planNorm, String(cuentaValida));
    const cuentaResueltaNum = Number(cuentaResueltaStr);
    const cuentaFinal = Number.isFinite(cuentaResueltaNum) && cuentaResueltaNum > 0
      ? cuentaResueltaNum
      : cuentaValida;
    const subcuenta = String(modeloNegocio?.subcuenta ?? '').trim().toUpperCase();
    const planCodi = Array.isArray(modeloNegocio?.programa)
      ? String(modeloNegocio?.programa?.[0] ?? '').trim().toUpperCase()
      : '';
    const prmTari = String(data?.prm_tari ?? '').trim();
    const prmEdad = String(data?.prm_edad ?? '').trim();
    const prmFecha = String(data?.prm_fecha ?? '').trim();
    const vigenDesde = String(data?.vigen_desde ?? '').trim();
    const prmParen = String(data?.prm_paren ?? '').trim();
    const prmSexo = String(data?.prm_sexo ?? '').trim().toUpperCase();
    const prmInteTipo = String(data?.prm_inte_tipo ?? '').trim().toUpperCase();
    const cantInte = String(data?.cant_inte ?? '').trim();

    this.ultimaMetaTarifasIndividuales = { legacyConDatos: false, valoresConDatos: false };

    if (esInclusion) {
      const jsonParams = {
        prm_cuenta: String(cuentaFinal),
        prm_subcta: subcuenta,
        prm_plan_codi: planCodi,
        prm_tari: prmTari,
        prm_edad: prmEdad,
        prm_fecha: prmFecha,
        vigen_desde: vigenDesde,
        prm_paren: prmParen,
        prm_sexo: prmSexo,
        prm_inte_tipo: prmInteTipo,
        cant_inte: cantInte
      };
      const body = { nombreClave: 'getTarifasCotizadortrl', jsonParametros: JSON.stringify(jsonParams) };

      return this.httpClient.post<any>(url, body).pipe(
        map((resp) => {
          if (!resp?.status) {
            throw new Error(resp?.message || 'No fue posible consultar las tarifas individuales de inclusión.');
          }
          const items = Array.isArray(resp?.data?.jsonRespuesta) ? resp.data.jsonRespuesta : (Array.isArray(resp?.data?.respuesta) ? resp.data.respuesta : []);
          const result: IListTarifa[] = items.map((it: any) => {
            const tarifa = String(it?.tari ?? it?.TARIFA_CODIGO ?? prmTari ?? '').trim();
            const descripcion = (it?.descripcion || it?.description || it?.tarifa_nombre || it?.TARIFA_NOMBRE || it?.nombreTarifa || '').toString().trim();
            const planCodigo = String(it?.plan_codi ?? it?.PLAN_CODIGO ?? planCodi ?? '').trim().split('|')[0].trim();
            const valorRaw = Number(it?.valor);
            const valorIvaRaw = Number(it?.valor_iva ?? it?.valorMensualIva);
            const valorIvaResolved = Number.isFinite(valorIvaRaw) ? valorIvaRaw : (Number.isFinite(valorRaw) ? valorRaw : NaN);
            const porcentajeIvaRaw = Number(it?.porcentaje_iva ?? it?.porcentajeIva);
            const grupoAdh = String(it?.grupo_adh ?? '').trim().toUpperCase();

            return {
              tarifa,
              descripcion,
              description: descripcion,
              programa_grupo: planCodigo,
              codigo_programa_grupo: planCodigo,
              programa: planCodigo,
              grupoPrograma: String(
                it?.GRUPO_PROGRAMA ??
                it?.grupoPrograma ??
                it?.grupo_programa ??
                ''
              )
              .split('|')[0]
              .trim()
              .toUpperCase(),
              valorMensualBase: Number.isFinite(valorRaw) ? valorRaw : undefined,
              valorMensualIva: Number.isFinite(valorIvaResolved) ? valorIvaResolved : undefined,
              porcentajeIva: Number.isFinite(porcentajeIvaRaw) ? porcentajeIvaRaw : undefined,
              esTarifaAsociado: grupoAdh === 'S'
            };
          });
          const resultUnico = result.filter((item, index, arr) => index === arr.findIndex((other) => other.tarifa === item.tarifa));
          this.ultimaMetaTarifasIndividuales = { legacyConDatos: false, valoresConDatos: resultUnico.length > 0 };
          return resultUnico;
        }),
        catchError(error => {
          this.ultimaMetaTarifasIndividuales = { legacyConDatos: false, valoresConDatos: false };
          const msg = error?.message || error?.error?.message || 'Error consultando tarifas individuales de inclusión';
          return throwError(() => new Error(msg));
        })
      );
    }

    return this.consultarTarifaIndividualLegacy(data).pipe(
      concatMap((legacyParams) => {
        if ((legacyParams?.legacyCount || 0) > 0 && (legacyParams?.matchedPlanCount || 0) === 0) {
          this.ultimaMetaTarifasIndividuales = {
            legacyConDatos: true,
            valoresConDatos: false
          };
          return of({ responses: [], legacyParams });
        }

        const tarifasLegacy = Array.isArray(legacyParams?.prm_tari_list)
          ? legacyParams!.prm_tari_list
            .map((t) => (t ?? '').toString().trim())
            .filter(Boolean)
          : [];

        const tarifasAConsultar = tarifasLegacy.length
          ? tarifasLegacy
          : [(legacyParams?.prm_tari || prmTari).toString().trim()];

        return from(tarifasAConsultar).pipe(
          concatMap((tarifaCodigo) => {
            const jsonParams = {
              prm_cuenta: String(cuentaFinal),
              prm_subcta: (legacyParams?.prm_subcta || subcuenta).toString().trim().toUpperCase(),
              prm_plan_codi: (legacyParams?.prm_plan_codi || planCodi).toString().trim().toUpperCase(),
              prm_tari: tarifaCodigo,
              prm_edad: prmEdad,
              prm_fecha: prmFecha,
              vigen_desde: vigenDesde,
              prm_paren: prmParen,
              prm_sexo: prmSexo,
              prm_inte_tipo: prmInteTipo,
              cant_inte: cantInte
            };

            const body = {
              nombreClave: 'getTarifasCotizadortrl',
              jsonParametros: JSON.stringify(jsonParams)
            };

            return this.httpClient.post<any>(url, body);
          }),
          toArray(),
          map((responses) => ({ responses, legacyParams }))
        );
      }),
      map(({ responses, legacyParams }) => {
        if ((legacyParams?.legacyCount || 0) > 0 && (legacyParams?.matchedPlanCount || 0) === 0) {
          return [] as IListTarifa[];
        }

        const allItems: any[] = [];

        responses.forEach((resp: any) => {
          if (!resp?.status) {
            throw new Error(resp?.message || 'No fue posible consultar las tarifas individuales.');
          }
          const items = Array.isArray(resp?.data?.jsonRespuesta)
            ? resp.data.jsonRespuesta
            : (Array.isArray(resp?.data?.respuesta) ? resp.data.respuesta : []);
          allItems.push(...items);
        });

        const result: IListTarifa[] = allItems.map((it: any) => {
          const tarifa = String(it?.tari ?? it?.TARIFA_CODIGO ?? '').trim();
          const descripcionFromLegacy = legacyParams?.tarifaNombreByCode?.[tarifa];
          const descripcion = (descripcionFromLegacy || tarifa).toString().trim();
          const planCodigo = String(it?.plan_codi ?? it?.PLAN_CODIGO ?? '').trim().split('|')[0].trim();
          const valorRaw = Number(it?.valor);
          const valorIvaRaw = Number(it?.valor_iva ?? it?.valorMensualIva);
          const valorIvaResolved = Number.isFinite(valorIvaRaw)
            ? valorIvaRaw
            : (Number.isFinite(valorRaw) ? valorRaw : NaN);
          const porcentajeIvaRaw = Number(it?.porcentaje_iva ?? it?.porcentajeIva);
          const grupoAdh = String(it?.grupo_adh ?? '').trim().toUpperCase();

          const tariTipoRaw = String(legacyParams?.tarifaTipoByCode?.[tarifa] ?? '').trim().toUpperCase();
          const tariTipo = (tariTipoRaw === 'I' || tariTipoRaw === 'C')
            ? (tariTipoRaw as 'I' | 'C')
            : null;

          return {
            tarifa,
            descripcion,
            description: descripcion,
            programa_grupo: planCodigo,
            codigo_programa_grupo: planCodigo,
            grupoPrograma: legacyParams?.grupoPrograma ?? '',
            programa: planCodigo,
            valorMensualBase: Number.isFinite(valorRaw) ? valorRaw : undefined,
            valorMensualIva: Number.isFinite(valorIvaResolved) ? valorIvaResolved : undefined,
            porcentajeIva: Number.isFinite(porcentajeIvaRaw) ? porcentajeIvaRaw : undefined,
            esTarifaAsociado: grupoAdh === 'S',
            // TARI_TIPO desde legacy
            tariTipo
          };
        });

        const resultUnico = result.filter((item, index, arr) =>
          index === arr.findIndex((other) => other.tarifa === item.tarifa)
        );

        this.ultimaMetaTarifasIndividuales = {
          legacyConDatos: Number(legacyParams?.legacyCount || 0) > 0,
          valoresConDatos: resultUnico.length > 0
        };

        return resultUnico;
      }),
      catchError(error => {
        this.ultimaMetaTarifasIndividuales = {
          legacyConDatos: false,
          valoresConDatos: false
        };
        const msg = error?.message || error?.error?.message || 'Error consultando tarifas individuales';
        return throwError(() => new Error(msg));
      })
    );
  }

  private consultarTarifaIndividualLegacy(data: IDataTarifa): Observable<TarifaLegacyLookupParams | null> {
    const url = this.servicioTarifaIndividualLegacy;
    const modeloNegocio = Array.isArray(data?.modelo_negocio) ? data.modelo_negocio[0] : null;
    const programa = Array.isArray(modeloNegocio?.programa)
      ? String(modeloNegocio?.programa?.[0] ?? '').trim().toUpperCase()
      : '';
    const plan = normTxt(localStorage.getItem('tipoPlan') || '');
    const planComparable = normalizeTipoPlanTarifa((data as any)?.codigo_tipo_plan ?? plan);

    const body = {
      nombreClave: 'getTarifasCotizador',
      jsonParametros: JSON.stringify({
        pnu_pagina: '1',
        pnu_tamanoPagina: '1000',
        lineaNegocio: String(modeloNegocio?.linea_negocio ?? ''),
        plan,
        grupoPrograma: '',
        programa,
        planTarifario: '',
        pvc_campoOrden: ''
      })
    };

    return this.httpClient.post<any>(url, body).pipe(
      map((resp) => {
        if (!resp?.status) return null;

        const items = Array.isArray(resp?.data?.jsonRespuesta)
          ? resp.data.jsonRespuesta
          : (Array.isArray(resp?.data) ? resp.data : []);
        const filteredItems = items.filter((it: any) => {
          const itemPlan = normalizeTipoPlanTarifa(it?.TIPO_PLAN);
          return !planComparable || !itemPlan || itemPlan === planComparable;
        });
        if (!items.length) return null;

        if (!filteredItems.length) {
          return {
            prm_subcta: '',
            prm_plan_codi: '',
            prm_tari: '',
            prm_tari_list: [],
            legacyCount: items.length,
            matchedPlanCount: 0,
            tarifaNombreByCode: {},
            tarifaTipoByCode: {},
            grupoPrograma: ''
          };
        }

        const first = filteredItems[0];
        const grupoPrograma = String(
          first?.GRUPO_PROGRAMA ?? ''
        )
          .split('|')[0]
          .trim()
          .toUpperCase();

        const prm_subcta = String(first?.SUBCUENTA ?? '').trim().toUpperCase();
        const prm_plan_codi = String(first?.PLAN_CODIGO ?? '').trim().split('|')[0].trim().toUpperCase();
        const prm_tari = String(first?.TARIFA_CODIGO ?? '').trim();
        const prm_tari_list: string[] = Array.from(new Set<string>(
          filteredItems
            .map((it: any) => String(it?.TARIFA_CODIGO ?? '').trim())
            .filter((code: string) => Boolean(code))
        ));
        const tarifaNombreByCode: Record<string, string> = {};
        const tarifaTipoByCode: Record<string, string> = {};

        filteredItems.forEach((it: any) => {
          const codigo = String(it?.TARIFA_CODIGO ?? '').trim();
          const nombre = String(it?.TARIFA_NOMBRE ?? '').trim();
          const tariTipo = String(it?.TARI_TIPO ?? '').trim();
          if (codigo && nombre) {
            tarifaNombreByCode[codigo] = nombre;
          }
          if (codigo && tariTipo) {
            tarifaTipoByCode[codigo] = tariTipo;
          }
        });

        if (!prm_subcta || !prm_plan_codi || !prm_tari) {
          return null;
        }

        return {
          prm_subcta,
          prm_plan_codi,
          prm_tari,
          prm_tari_list,
          legacyCount: items.length,
          matchedPlanCount: filteredItems.length,
          tarifaNombreByCode,
          tarifaTipoByCode,
          grupoPrograma
        };
      }),
      catchError(() => of(null))
    );
  }

  consultarTarifasDatos(prm_cuenta: number | string, prm_subcta: string, prm_plan_codi: string) {
    const url = this.servicioTarifaColectiva;
    const body = {
      nombreClave: 'getCotConsultarTarifa',
      jsonParametros: JSON.stringify({
        prm_cuenta: String(prm_cuenta),
        prm_subcta: String(prm_subcta),
        prm_plan_codi: String(prm_plan_codi)
      })
    };

    return this.httpClient.post<any>(url, body).pipe(
      map((resp) => {
        if (!resp?.status) {
          throw new Error(resp?.message || 'No fue posible consultar las tarifas.');
        }
        const lista = Array.isArray(resp?.data) ? resp.data : [];
        return lista.map((it: any) => ({
          tarifa: it.tarifa_codigo,
          descripcion: it.tarifa_nombre,
          programa_grupo: it.plan_codigo,
          codigo_programa_grupo: it.plan_codigo,
          programa: it.plan_nombre
        }));
      }),
      catchError(error => {
        let msg = 'No fue posible consultar las tarifas en este momento.';
        if (error?.error?.message) {
          msg = error.error.message;
        }
        return throwError(() => new Error(msg));
      })
    );
  }

  getTypeDocument(): Observable<Array<documentsType>> {
    const url = this.servicioDocuemento;
    const body = {
      nombreClave: 'getSpDocuTipos',
      jsonParametros: '{}',
    };

    return this.httpClient.post<ModelDefaultResponse<any>>(url, body).pipe(
      map((response: any) => {
        if (!response || !response.status) {
          throw new Error(
            response?.message || 'Error consultando tipos de documento',
          );
        }
        return response.data as Array<documentsType>;
      }),
      catchError(error => {
        return throwError(() => new Error((error) ? error : "Problema consultando tipo de documento"));
      })
    );
  }

  searchPeople(data: QuotationPeopleeRequest): Observable<QuotationPeopleeResponse> {
    const url = this.servicioDatosUsuario;
    const payload = {
      tipoDocumento: data.tipoDocumento,
      numeroDocumento: data.numeroDocumento
    };

    return this.httpClient.post<any>(url, payload).pipe(
      map((response: any) => {
        if (!response || typeof response !== 'object') {
          throw new Error('No se encontraron datos de usuario con la información ingresada');
        }
        const u = response.data;

        if (!response.status || !u) {
          throw new Error(response?.errorMessage || 'No se encontraron datos de usuario con la información ingresada');
        }

        const noHayNombre =
          (u.primerNombre == null || u.primerNombre === '') &&
          (u.primerApellido == null || u.primerApellido === '');
        const marcadoNoEncontrado =
          u.encontradoEnAfilmed === false || !!u.errorAfilmed;
        if (marcadoNoEncontrado && noHayNombre) {
          const msg = u?.errorAfilmed?.mensaje || 'No se encontró información en AFILMED';
          throw new Error(msg);
        }

        return u as QuotationPeopleeResponse;

      }),
      catchError(error => {
        const errorMessage =
          error?.message || error?.error?.message || 'No se encontró información en AFILMED';
        return throwError(() => new Error(errorMessage));
      })
    );
  }

  // Apagado temporal: no llama ADRES. Poner true cuando el servicio esté listo.
  private readonly CONSULTA_ADRES_HABILITADA = false;

  consultarAdres(tipoDocumento: string, numeroDocumento: string): Observable<AdresPerson> {
    if (!this.CONSULTA_ADRES_HABILITADA) {
      return of({
        codeStatus: '503',
        message: 'Servicio inactivo',
        afiliacion: null
      } as any);
    }

    const url = this.servicioAdres;
    const body = {
      nombreClave: 'getAdresPeople',
      queryParams: `?documento=${encodeURIComponent(numeroDocumento)}&tipo_documento=${encodeURIComponent(tipoDocumento)}`,
      body: null
    };

    return this.httpClient.post<AdresResponse>(url, body).pipe(
      map((response: any) => {
        if (!response) {
          throw new Error('Respuesta vacía del servicio ADRES');
        }

        if (response.status !== true || !response.data) {
          const msg =
            response?.message ||
            response?.data?.errorMessage ||
            'No se pudo consultar ADRES';
          throw new Error(msg);
        }

        return response.data as AdresPerson;
      }),

      catchError((error) => {
        const msg =
          error?.message ||
          error?.error?.message ||
          'Error consultando ADRES';
        return throwError(() => new Error(msg));
      })
    );
  }

  consultarCiudades(): Observable<ConsultarCiudadesResponse> {
    const url = this.servicioCiudad;

    return this.httpClient.get<ConsultarCiudadesResponse>(url).pipe(
      catchError(error => {
        return throwError(() => new Error(error?.message || 'Error al consultar ciudades'));
      })
    );
  }

  consultarActivoAcColectivo(documento: string, tipoDocumento: string, evaluador: string) {
    const url = this.servicioActivoAC;
    const body = {
      nombreClave: 'getconsultacolectivoac',
      jsonParametros: JSON.stringify({
        documento,
        tipoDocumento,
        evaluador
      })
    };

    return this.httpClient.post<any>(url, body).pipe(
      map(resp => {
        if (resp?.status !== true) return [] as ActivoAcColectivoItem[];
        const data = Array.isArray(resp?.data?.jsonRespuesta)
          ? resp.data.jsonRespuesta
          : (Array.isArray(resp?.data) ? resp.data : []);
        return data as ActivoAcColectivoItem[];
      }),
      catchError(_ => of([] as ActivoAcColectivoItem[]))
    );
  }

  consultarActivoAcColectivoFromLocal() {
    const { documento, tipoDocumento } = this.getDocFromLocal();
    const plan = this.getTipoPlanFromLocal() || 'C';
    const evaluador = (plan === 'GA' || plan === 'AG') ? 'AC' : plan;
    if (!documento || !tipoDocumento) {
      return of([] as ActivoAcColectivoItem[]);
    }
    return this.consultarActivoAcColectivo(documento, tipoDocumento, evaluador);
  }

  consultarSubcuentas(programa: string): Observable<ConsultarSubcuentasResponse> {
    const url = this.servicioSubcuentas;
    const request: ConsultarSubcuentasRequest = {
      nombreClave: 'getSpSubcuentaPrograma',
      jsonParametros: JSON.stringify({ prm_programa: programa })
    };

    return this.httpClient.post<ConsultarSubcuentasResponse>(url, request).pipe(
      catchError(error => {
        return throwError(() => new Error(error?.message || 'Error al consultar subcuentas'));
      })
    );
  }

  consultarTiposVia(): Observable<TipoViaItem[]> {
    const url = this.servicioTipoVia;
    const body: ConsultarTipoViaRequest = {
      nombreClave: 'getCotConsultarTipoVia',
      jsonParametros: '{}'
    };

    return this.httpClient.post<ConsultarTipoViaBackendResponse>(url, body).pipe(
      map((resp) => {
        if (!resp?.status) {
          throw new Error(resp?.message || 'No fue posible consultar los tipos de vía.');
        }
        const data = (resp as any).data;
        const lista: TipoViaItem[] = Array.isArray(data)
          ? data
          : Array.isArray(data?.jsonRespuesta)
            ? data.jsonRespuesta
            : [];
        return lista;
      }),
      catchError((error) => {
        const msg = error?.message || error?.error?.mensaje || 'Error consultando tipos de vía';
        return throwError(() => new Error(msg));
      })
    );
  }

  consultarAnexos(
    prm_cuenta: string,
    prm_subcta: string,
    prm_plan_grupo: string,
    prm_plan_codi = '',
    prm_edad = '',
    prm_sexo = ''
  ): Observable<any> {
    const url = this.servicioAnexos;
    const planNorm = normTxt(this.getTipoPlanFromLocal() || localStorage.getItem('tipoPlan') || '');
    const cuentaNum = Number(prm_cuenta);
    const cuentaValida = Number.isFinite(cuentaNum) && cuentaNum > 0 ? String(cuentaNum) : '1';
    const cuentaResuelta = resolverCuentaPorTipoPlan(planNorm, cuentaValida);

    const esColectivoOAfinidad = planNorm === 'C' || planNorm === 'CY' || planNorm === 'GA' || planNorm === 'AG' || planNorm.includes('COLECTIV') || planNorm.includes('AFINIDAD');

    const jsonParams = esColectivoOAfinidad ? {
      prm_cuenta: cuentaResuelta,
      prm_subcta: (prm_subcta ?? '').toString().trim(),
      prm_plan_grupo,
      prm_plan_codi: '',
      prm_edad,
      prm_sexo
    } : {
      prm_cuenta: cuentaResuelta,
      prm_plan_codi: (prm_plan_codi ?? '').toString().trim().toUpperCase(),
      prm_edad,
      prm_sexo,

      prm_subcta: (() => {
        const subctaPasada = (prm_subcta ?? '').toString().trim().toUpperCase();


        const subcuentasValidas = ['ASMP', 'EMSMP', 'FSMP', 'ASAO', 'FSAO', 'EMSAO', 'ACEMN', 'EMCMN', 'FCEMN'];
        if (subctaPasada && subcuentasValidas.includes(subctaPasada)) {
          return subctaPasada;
        }

        const planCodiClean = (prm_plan_codi ?? '').toString().trim().toUpperCase();
        let linea = 'SMP';
        if (planCodiClean.startsWith('DE') || planCodiClean.includes('SAO') || planCodiClean.includes('SO')) {
          linea = 'SAO';
        } else if (planCodiClean.includes('CEM')) {
          linea = 'CEM';
        }

        let tipo = 'F';
        if (planNorm === 'A' || planNorm === 'AS' || planNorm.includes('ASOCIADO')) tipo = 'A';
        else if (planNorm === 'E' || planNorm === 'EMP' || planNorm.includes('EMPLEADO')) tipo = 'E';

        const matrizSubcuentas: Record<string, Record<string, string>> = {
          'SMP': { 'A': 'ASMP', 'F': 'FSMP', 'E': 'EMSMP' },
          'SAO': { 'A': 'ASAO', 'F': 'FSAO', 'E': 'EMSAO' },
          'CEM': { 'A': 'ACEMN', 'F': 'FCEMN', 'E': 'EMCMN' }
        };

        return matrizSubcuentas[linea]?.[tipo] || 'FSMP';
      })()
    };

    const body = {
      nombreClave: 'getCotConsultarAnexosAfilmed',
      jsonParametros: JSON.stringify(jsonParams)
    };

    return this.httpClient.post<any>(url, body).pipe(
      map(resp => {
        if (!resp?.status) {
          throw new Error(resp?.message || 'No fue posible consultar anexos.');
        }
        const lista = Array.isArray(resp?.data?.jsonRespuesta) ? resp.data.jsonRespuesta : (Array.isArray(resp?.data) ? resp.data : []);
        return lista.map((it: any) => ({
          plan_cod1: (it?.plan_cod1 ?? it?.plan_codi ?? '').toString().trim(),
          plan_cod2: (it?.plan_cod2 ?? it?.plan_codi_adi ?? '').toString().trim(),
          plan_desc: (it?.plan_desc ?? it?.deno ?? '').toString().trim(),
          valor: (it?.valor ?? '').toString().trim(),
          tari: (it?.tari ?? '').toString().trim()
        }));
      }),
      catchError(err => {
        const msg = err?.message || err?.error?.message || 'Error consultando anexos';
        return throwError(() => new Error(msg));
      })
    );
  }

  private buildDatosBeneficiariosPayload(b: Beneficiarios) {
    const esUsuLS = getEsUsuarioFromLocalContratante();
    const esContratanteFinal =
      (typeof b.es_contratante === 'boolean') ? b.es_contratante :
        (typeof esUsuLS === 'boolean' ? esUsuLS : false);
    const idContratante = getIdContratanteFromLocal();
    const idCotLocal = getIdCotizacionFromLocal();
    const idCotizacion =
      Number(b.id_cotizacion || 0) > 0
        ? Number(b.id_cotizacion)
        : (Number(idCotLocal || 0));

    const body: any = {
      idCotizacion: idCotizacion || 0,
      esContratante: esContratanteFinal,
      parentescoId: (b.parentesco_id || '').toString(),
      tipoDocumento: (b.tipo_documento || '').toString(),
      numDocumento: (b.num_documento || '').toString(),
      primerNombre: (b.primer_nombre || '').toString(),
      segundoNombre: (b.segundo_nombre || '').toString(),
      primerApellido: (b.primer_apellido || '').toString(),
      segundoApellido: (b.segundo_apellido || '').toString(),
      genero: (
        (b.genero || '').trim() === '1' ? 'F'
          : ((b.genero || '').trim() === '2' ? 'M' : (b.genero || '').toString().toUpperCase())
      ),
      fechaNacimiento: (b.fecha_nacimiento || '').toString().trim(),
      edad: Number(b.edad || 0)
    };

    if (idContratante != null) {
      body.idContratante = idContratante;
    }

    return body;
  }

  guardarDatosBeneficiarios(b: Beneficiarios) {
    const url = this.servicioDatosBeneficiarios;
    const body = this.buildDatosBeneficiariosPayload(b);

    return this.httpClient.post<any>(url, body);
  }

  actualizarDatosBeneficiarios(idBeneficiario: number, b: Beneficiarios) {
    const url = `${this.servicioActualizarDatosBeneficiarios}/${idBeneficiario}`;
    const body = this.buildDatosBeneficiariosPayload(b);

    return this.httpClient.put<any>(url, body);
  }

  eliminarDatosBeneficiarios(idBeneficiario: number) {
    return this.httpClient.delete<any>(`${this.servicioEliminarDatosBeneficiarios}/${idBeneficiario}`);
  }

  // Guardar Beneficiario–Programas
  guardarBeneficiarioProgramas(payload: {
    idCotizacion: number;
    idBeneficiario: number;
    items: Array<{
      lineaNegocio: 'MI' | 'SO' | 'CEM' | string;
      programa: string;
      nombrePrograma?: string;
      grupoPrograma?: string;
      esAnexo?: boolean;
    }>;
  }, replace = false) {
    const url = replace
      ? `${this.servicioGuardarBeneficiarioProgramas}?replace=true`
      : this.servicioGuardarBeneficiarioProgramas;

    const normalizedPayload = {
      ...payload,
      items: (payload.items || []).map((item) => ({
        ...item,
        lineaNegocio: normTxt(item?.lineaNegocio) === 'SO' ? 'SAO' : (item?.lineaNegocio || ''),
        grupoPrograma: (item?.grupoPrograma || '').toString().trim()
      }))
    };

    return this.httpClient.post<any>(url, normalizedPayload);
  }

  // Guardar Subcuentas (estructura simple, sin programa)
  guardarSubcuentas(payload: {
    idCotizacion: number;
    idBeneficiario: number;
    subcuentas: Array<{
      subcta: string;
      nombreSubcuenta?: string;
      planCodi?: string;
    }>;
  }, replace = false) {
    const url = replace
      ? `${this.servicioGuardarSubcuenta}?replace=true`
      : this.servicioGuardarSubcuenta;
    return this.httpClient.post<any>(url, payload);
  }

  actualizarSubcuentas(idSubcuenta: number, body: {
    subcta: string;
    nombreSubcuenta?: string;
    planCodi?: string;
  }) {
    return this.httpClient.put<any>(`${this.servicioActualizarSubcuenta}/${idSubcuenta}`, body);
  }

  // Guardar Tarifas
  guardarTarifas(payload: {
    idCotizacion: number;
    idBeneficiario: number;
    programas: Array<{
      idBenPrograma: number;
      tarifas: Array<{
        tari: string;
        nombreTarifa?: string;
        valorMensualBase?: number;
        valorMensualIva?: number;
        porcentajeIva?: number;
        esTarifaAsociado?: boolean;
        fueSeleccionada: boolean;
        esAnexo?: boolean;
      }>;
    }>;
  }, replace = false) {
    const url = replace
      ? `${this.servicioGuardarTarifa}?replace=true`
      : this.servicioGuardarTarifa;
    return this.httpClient.post<any>(url, payload);
  }

  actualizarTarifas(idCotizacionTarifa: number, body: {
    tari: string;
    nombreTarifa?: string;
    valorMensualBase?: number;
    valorMensualIva?: number;
    porcentajeIva?: number;
    esTarifaAsociado?: boolean;
    fueSeleccionada: boolean;
    esAnexo?: boolean;
  }) {
    return this.httpClient.put<any>(`${this.servicioActualizarTarifa}/${idCotizacionTarifa}`, body);
  }

  eliminarTarifa(idCotizacionTarifa: number) {
    return this.httpClient.delete<any>(`${this.servicioEliminarTarifas}/${idCotizacionTarifa}`);
  }

  // Guardar Campañas
  guardarCampanias(payloadOrParams:
    | {
      idCotizacion: number;
      idBeneficiario: number;
      programas: Array<{
        idBenPrograma: number;
        campanias: Array<{
          codCampComercial: string;
          nombreCampania?: string;
          tipoCampania?: string;
          modalidad?: string;
          fueSeleccionada: boolean;
          cuenta?: string;
          subcuenta?: string;
          tipoPlan?: string;
          parentesco?: string;
          edadDesde?: number;
          edadHasta?: number;
          cantBenefDesde?: number;
          cantBenefHasta?: number;
          acumulable?: boolean;
          pagoDebitoAuto?: boolean;
          aplicaProntoPago?: boolean;
          observaciones?: string;
          usuarioActualizacion?: string;
          lineaNegocio?: string;
          grupoPrograma?: string;
          programa?: string;
          inicioVigencia?: string;
          finVigencia?: string;
          estado?: boolean;
        }>;
      }>;
    }
    | {
      idCotizacion: number;
      idBeneficiario: number;
      programasSeleccionados: ProgramaSeleccionadoCampaniaInput[];
    }
    , replace = false) {
    const url = replace
      ? `${this.servicioGuardarCampanias}?replace=true`
      : this.servicioGuardarCampanias;
    const payload = 'programasSeleccionados' in payloadOrParams
      ? this.buildCampaniasPayloadFromSeleccion(payloadOrParams)
      : payloadOrParams;

    return this.httpClient.post<any>(url, payload);
  }

  actualizarCampanias(idCotizacionCampania: number, body: {
    codCampComercial: string;
    nombreCampania?: string;
    tipoCampania?: string;
    modalidad?: string;
    fueSeleccionada: boolean;
    cuenta?: string;
    subcuenta?: string;
    tipoPlan?: string;
    parentesco?: string;
    edadDesde?: number;
    edadHasta?: number;
    cantBenefDesde?: number;
    cantBenefHasta?: number;
    acumulable?: boolean;
    pagoDebitoAuto?: boolean;
    aplicaProntoPago?: boolean;
    observaciones?: string;
    usuarioActualizacion?: string;
    lineaNegocio?: string;
    grupoPrograma?: string;
    programa?: string;
    inicioVigencia?: string;
    finVigencia?: string;
    estado?: boolean;
  }) {
    return this.httpClient.put<any>(`${this.servicioActualizarCampanias}/${idCotizacionCampania}`, body);
  }

  eliminarCampania(idCotizacionCampania: number) {
    return this.httpClient.delete<any>(`${this.servicioEliminarCampanias}/${idCotizacionCampania}`);
  }

  private buildCampaniasPayloadFromSeleccion(params: {
    idCotizacion: number;
    idBeneficiario: number;
    programasSeleccionados: ProgramaSeleccionadoCampaniaInput[];
  }) {
    const programas = (params.programasSeleccionados || []).map(ps => {
      const idBenPrograma = Number(ps?.__idBenPrograma || 0);
      const lista = Array.isArray(ps?.campaniasDisponibles) ? ps.campaniasDisponibles : [];
      const codSel = (ps?.campana || '').toString().trim();
      const detSel = lista.find(c => normTxt(c?.codigo_campania) === normTxt(codSel) || normTxt(c?.nombre) === normTxt(codSel));
      const codCampComercial = (detSel?.codigo_campania || codSel).toString().trim();
      const nombreCampania = (detSel?.nombre || ps?.campanaNombre || (detSel ? codSel : '')).toString().trim();
      const esFlujoInclusion = localStorage.getItem('tipoSolicitud') === '2' || (ps as any).esInclusion === true;

      let codCuenta = '';

      if (esFlujoInclusion) {
        codCuenta = ((ps as any).cuenta || (ps as any).grupo || '').toString().trim();
      } else {
        codCuenta = (detSel?.cuenta ?? '').toString().trim();
      }

      return {
        idBenPrograma,
        campanias: [{
          codCampComercial,
          nombreCampania,
          tipoCampania: (detSel?.tipo_campania || '').toString().trim(),
          modalidad: (detSel?.modalidad || '').toString().trim(),
          fueSeleccionada: true,
          cuenta: codCuenta,
          subcuenta: (detSel?.subcuenta ?? '').toString().trim(),
          tipoPlan: (detSel?.tipo_plan ?? '').toString().trim(),
          parentesco: (detSel?.parentesco ?? '').toString().trim(),
          edadDesde: toSafeNumber(detSel?.edad_desde, 0),
          edadHasta: toSafeNumber(detSel?.edad_hasta, 0),
          cantBenefDesde: toSafeNumber(detSel?.cant_benef_desde, 0),
          cantBenefHasta: toSafeNumber(detSel?.cant_benef_hasta, 0),
          acumulable: detSel?.acumulable === true,
          pagoDebitoAuto: detSel?.pago_debito_auto === true,
          aplicaProntoPago: detSel?.aplica_pronto_pago === true,
          observaciones: (detSel?.observaciones ?? '').toString().trim(),
          usuarioActualizacion: (detSel?.usuario_actualizacion ?? '').toString().trim(),
          lineaNegocio: (detSel?.linea_negocio ?? '').toString().trim(),
          grupoPrograma: (detSel?.grupo_programa ?? '').toString().trim(),
          programa: (detSel?.programa ?? '').toString().trim(),
          inicioVigencia: normalizeCampaignDate(detSel?.inicio_vigencia),
          finVigencia: normalizeCampaignDate(detSel?.fin_vigencia),
          estado: detSel?.estado === true
        }]
      };
    });

    return { idCotizacion: params.idCotizacion, idBeneficiario: params.idBeneficiario, programas };
  }

  eliminarBeneficiarioPrograma(idBenPrograma: number) {
    return this.httpClient.delete<any>(`${this.servicioEliminarBeneficiarioProgramas}/${idBenPrograma}`);
  }

  eliminarSubcuenta(idSubcuenta: number) {
    return this.httpClient.delete<any>(`${this.servicioEliminarSubcuentas}/${idSubcuenta}`);
  }

  actualizarBeneficiarioPrograma(idBenPrograma: number, body: {
    lineaNegocio: string;
    programa: string;
    nombrePrograma?: string;
    grupoPrograma?: string;
    esAnexo?: boolean;
  }) {
    const normalizedBody = {
      ...body,
      lineaNegocio: normTxt(body?.lineaNegocio) === 'SO' ? 'SAO' : (body?.lineaNegocio || ''),
      grupoPrograma: (
        body?.grupoPrograma ?? ''
      ).toString().trim()
    };
    return this.httpClient.put<any>(`${this.servicioActualizarBeneficiarioProgramas}/${idBenPrograma}`, normalizedBody);
  }

  consultarBeneficiarioPrograma(params: { idCotizacion: number; idBeneficiario: number; programa: string; }) {
    const url = this.servicioConsultarBeneficiarioPrograma;

    return this.httpClient.post<any>(url, null, {
      params: {
        idCotizacion: String(params.idCotizacion),
        idBeneficiario: String(params.idBeneficiario),
        programa: params.programa
      }
    });
  }

  getSubcuentasConColectivoPrimero(programa: string, tipoDocumento: string, numeroDocumento: string, esPlanColectivo: boolean): Observable<SubcuentasOrquestadoResult> {
    const esColectivo = this.esPlanColectivoDesdeLS();
    const colectivo$ = esColectivo
      ? this.consultarActivoAcColectivoFromLocal()
      : of([]);

    return colectivo$.pipe(
      concatMap((items: ActivoAcColectivoItem[]) => {
        let cuenta: number | undefined;
        let subctaSugerida: string | null = null;
        let planCodiColectivo: string | null = null;

        const activosNormalizados = (Array.isArray(items) ? items : [])
          .map((it: ActivoAcColectivoItem) => ({
            cuenta: Number((it?.cuenta ?? '').toString().trim()),
            subcta: (it?.subcta ?? '').toString().trim(),
            planCodi: (it?.plan_codi ?? '').toString().trim()
          }))
          .filter((it: any) => Number.isFinite(it.cuenta) && it.cuenta > 0 && !!it.subcta);

        if (activosNormalizados.length) {
          cuenta = activosNormalizados[0].cuenta;
          subctaSugerida = activosNormalizados[0].subcta || null;
          planCodiColectivo = activosNormalizados[0].planCodi || null;
        }

        return this.consultarSubcuentas(programa).pipe(
          map(indResp => {
            const raw = Array.isArray(indResp?.data?.jsonRespuesta) ? indResp.data.jsonRespuesta : [];
            let denoFromColectivo: string | null = null;

            for (const activo of activosNormalizados) {
              const hit = raw.find((r: any) =>
                buildPairKey(r?.cuenta, r?.subcta) === buildPairKey(activo.cuenta, activo.subcta)
              );

              if (hit) {
                cuenta = activo.cuenta;
                subctaSugerida = activo.subcta || null;
                planCodiColectivo = activo.planCodi || null;
                denoFromColectivo = hit?.deno ? (hit.deno as string).toString().trim() : null;
                break;
              }
            }

            return { cuenta, subctaSugerida, planCodiColectivo, rawIndividual: raw, denoFromColectivo };
          })
        );
      }),
      catchError(() => of({ cuenta: undefined, subctaSugerida: null, planCodiColectivo: null, rawIndividual: [], denoFromColectivo: null }))
    );
  }

  private getDocFromLocal(): { documento: string | null; tipoDocumento: string | null; } {
    try {
      const raw = localStorage.getItem('contrato_radicado');
      if (!raw) return { documento: null, tipoDocumento: null };

      const parsed = JSON.parse(raw);
      const documento = parsed?.persona?.docu_nro?.toString().trim() || null;
      const tipoDocumento = parsed?.persona?.docu_tipo?.toString().trim() || null;

      return { documento, tipoDocumento };
    } catch {
      return { documento: null, tipoDocumento: null };
    }
  }

  private getTipoPlanFromLocal(): string | null {
    try {
      const plan = (localStorage.getItem('tipoPlan') || '').toString().trim().toUpperCase();
      if (!plan) return null;
      if (plan.includes('COLECTIV')) return 'C';
      if (plan.includes('AFINIDAD')) return 'GA';
      return plan;
    } catch {
      return null;
    }
  }

  private esPlanColectivoDesdeLS(): boolean {
    try {
      const plan = (localStorage.getItem('tipoPlan') || '')
        .toString()
        .trim()
        .toUpperCase();

      if (!plan) return false;
      if (plan === 'C' || plan === 'CY') return true;
      if (plan === 'GA') return true;
      if (plan.includes('COLECTIV')) return true;
      if (plan.includes('AFINIDAD')) return true;
      return false;
    } catch {
      return false;
    }
  }
}